"use client"

import Link from "next/link"
import Image from "next/image"
import { usePathname } from "next/navigation"
import { useState } from "react"
import { Menu, X } from "lucide-react"

const navLinks = [
  { href: "#services", label: "خدماتنا" },
  { href: "#ai-bot", label: "بوت AI" },
  { href: "#branches", label: "فروعنا" },
  { href: "#contact", label: "تواصل معنا" },
]

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false)
  const pathname = usePathname()
  const prefix = pathname === "/" ? "" : "/"

  const resolveHref = (href: string) => (href.startsWith("#") ? `${prefix}${href}` : href)

  return (
    <header className="fixed top-0 left-0 right-0 z-40 p-4">
      <nav className="max-w-5xl mx-auto flex items-center justify-between h-14 px-6 rounded-full bg-zinc-900/70 border border-zinc-800/50 backdrop-blur-md">
        <Link href="/" className="flex items-center gap-3">
          <div className="relative w-9 h-9 rounded-full overflow-hidden">
            <Image
              src="/logo.jpeg"
              alt="Anmka Logo"
              fill
              className="object-cover"
            />
          </div>
          <span className="font-display text-xl font-bold text-zinc-100">
            Anmka <span className="text-zinc-400 text-sm font-normal">انمكا</span>
          </span>
        </Link>
        
        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={resolveHref(link.href)}
              className="px-4 py-1.5 text-sm rounded-full transition-colors text-zinc-400 hover:text-zinc-100"
            >
              {link.label}
            </Link>
          ))}
          <Link
            href={resolveHref("#contact")}
            className="me-2 px-4 py-1.5 text-sm rounded-full bg-zinc-100 text-zinc-900 font-medium hover:bg-zinc-200 transition-colors"
          >
            احصل على عرض سعر
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-zinc-100 p-2"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden mt-2 mx-4 p-4 rounded-2xl bg-zinc-900/95 border border-zinc-800/50 backdrop-blur-md">
          <div className="flex flex-col gap-2">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={resolveHref(link.href)}
                className="px-4 py-3 text-sm rounded-xl transition-colors text-zinc-400 hover:text-zinc-100 hover:bg-zinc-800/50"
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link
              href={resolveHref("#contact")}
              className="mt-2 px-4 py-3 text-sm text-center rounded-xl bg-zinc-100 text-zinc-900 font-medium hover:bg-zinc-200 transition-colors"
              onClick={() => setIsOpen(false)}
            >
              احصل على عرض سعر
            </Link>
          </div>
        </div>
      )}
    </header>
  )
}
